"use strict";
exports.__esModule = true;
var constraints_1 = require("../logic/constraints");
angular.module('smartorg.r6.acts.inputScreen').directive('inputScreenConstraint', function ($timeout) {
    return {
        require: 'ngModel',
        scope: {
            origValue: '=',
            constraint: '=',
            args: '=',
            index: '='
        },
        link: function (scope, elm, attrs, ctrl) {
            var thisScope = scope;
            function validate(viewValue) {
                if (scope.constraint instanceof Array) {
                    for (var _i = 0, _a = scope.constraint; _i < _a.length; _i++) {
                        var el = _a[_i];
                        var res = onValidate(el, viewValue);
                        if (res === undefined) { // Break loop if any of the validation is failed
                            break;
                        }
                        // No need to return a value since it is setting distribution values from FormattedValue
                    }
                    return viewValue;
                }
                else {
                    return onValidate(scope.constraint, viewValue);
                }
            }
            function onValidate(constraint, viewValue) {
                if (typeof viewValue !== 'string' && viewValue !== undefined) {
                    viewValue = viewValue.toString();
                }
                var validation = new constraints_1["default"](constraint);
                // Speacial Cases
                var args = scope.args;
                var isDistribution = Array.isArray(args.Val);
                if (args && (args.Max !== undefined || args.Min !== undefined)) {
                    // For % if not formatted value then divide it to 100
                    if (args.Options && args.Options.style === "percent" &&
                        ((isDistribution && (!args.isFormatted || !args.isFormatted[scope.index])) || (!isDistribution && !args.isFormatted))) {
                        args.Value = viewValue / 100;
                    }
                    else {
                        args.Value = viewValue;
                    }
                    return markAsValid(validation.isValidFor(args), viewValue, validation.errorMessage());
                }
                // Normal Case
                else {
                    return markAsValid(validation.isValidFor(viewValue), viewValue, validation.errorMessage());
                }
            }
            function markAsValid(isValid, viewValue, errorMessage) {
                ctrl.$setValidity('inputValidity', isValid);
                if (isValid) {
                    console.log("validddddd");
                    if (Number(viewValue) === Number(scope.origValue)) {
                        ctrl.$setPristine();
                    }
                    return viewValue;
                }
                else {
                    console.log("INVALID");
                    // Try setting in different scopes to find the right one
                    thisScope.$parent.errorMessage = errorMessage;
                    thisScope.errorMessage = errorMessage;
                    thisScope.$parent.$parent.errorMessage = errorMessage;
                    return undefined;
                }
            }
            ctrl.$parsers.unshift(validate);
            ctrl.$formatters.unshift(validate);
        }
    };
});
//# sourceMappingURL=smart-constraint-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/app/js/plumbing/smart-constraint-directive.js